

import {
  Box,
  Divider,
  LinearProgress,
  useMediaQuery,
  Button,
  CircularProgress,
  Typography,
  Avatar,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomText, { textStyles } from "../../../../components/CustomText";
import back from "../../../../assets/back.svg";
import projecticon from "../../../../assets/Projects/projecticon.svg";
import Progress from "../../../../assets/Projects/Progress.svg";
import document1 from "../../../../assets/document1.svg";
import document2 from "../../../../assets/Projects/document2.png";
import AddIcon from "@mui/icons-material/Add";
import StatusDropdown from "../../../../components/StatusDropdown";
import person1 from "../../../../assets/Dashboard/person1.svg";
import activity from "../../../../assets/Projects/activity.png";
import { showUnderDevelopment } from "../../../../components/Alert.js";
import { useState,useEffect } from "react";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { BASE_URL } from "../../../../components/BaseUrl";
import TaskStatusDropdown from "../../../../components/TaskStatusDropdown.js";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import emptyperson from "../../../../assets/emptyperson.jpeg"
import ClearIcon from "@mui/icons-material/Clear";
import {toast} from "react-hot-toast"
import { convertUTCToLocalDateTime } from "../../../../components/dateTimeUtils";
const TaskDetails = ({ task, onBack }) => {
  const isMobile = useMediaQuery("(max-width:768px)");
  const { t, i18n } = useTranslation();
    const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
const [comments, setComments] = useState([]);

  useEffect(() => {
    if (task?.comments) {
      setComments(task.comments);
    }
  }, [task]);
  const [newComment, setNewComment] = useState("");
  const [sending, setSending] = useState(false);


    // Example: "11 Sept 2025"
const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  const formatted = convertUTCToLocalDateTime(dateString, {
    locale: "en-GB",
    formatOptions: {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    },
  });

  return formatted === "—" ? "-" : formatted;
};
const [commentAttachment, setCommentAttachment] = useState(null); // uploaded file URL

const handleFileChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const formData = new FormData();
  formData.append("image", file);

  try {
    const res = await fetch(`${BASE_URL}/upload/image`, {
      method: "POST",
      body: formData,
    });
    const data = await res.json();

    if (!data.error && data.data?.url) {
      setCommentAttachment(data.data.url);
      toast.success("Attachment uploaded!");
    } else {
      toast.error("Failed to upload attachment");
    }
  } catch (err) {
    console.error("❌ Upload error:", err);
    toast.error("Error uploading file");
  }
};


const handleAddComment = async () => {
  if (!newComment.trim() && !commentAttachment) return;

  setSending(true);
  try {
    const res = await fetch(`${BASE_URL}/task-management/admin/tasks/${task.id}/comments`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${decryptedToken}`,
      },
      body: JSON.stringify({
        body: newComment,
        attachments: commentAttachment ? [commentAttachment] : [],
      }),
    });

    const data = await res.json();
    if (!data.error) {
      setComments((prev) => [...prev, data.data.comment]);
      setNewComment("");
      setCommentAttachment(null);
    } else {
      toast.error(data.message || "Failed to add comment");
    }
  } catch (err) {
    console.error("❌ Error adding comment:", err);
    toast.error("Error adding comment");
  } finally {
    setSending(false);
  }
};

const [updatingPriority, setUpdatingPriority] = useState(false);

const handlePriorityChange = async (newPriority) => {
  setUpdatingPriority(true);
  try {
    const res = await fetch(`${BASE_URL}/task-management/admin/tasks/${task.id}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${decryptedToken}`,
      },
      body: JSON.stringify({ priority: newPriority }),
    });

    const data = await res.json();
    if (!data.error) {
      task.priority = newPriority; // update UI
      toast.success("Priority updated successfully");
      window.dispatchEvent(new Event('tasks:updated')); // ✅ refresh calendar & map
    } else {
      toast.error(data.message || "Failed to update priority");
    }
  } catch (err) {
    console.error("❌ Error updating priority:", err);
    toast.error("Error updating priority");
  } finally {
    setUpdatingPriority(false);
  }
};


  if (!task) {
    return (
         <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "70vh",
      }}
    >
      <CircularProgress size={40} /> 
    </Box>
    );
  }
    const handleRemoveAttachment = () => {
    setCommentAttachment(null); // Remove the attachment
  };
  return (
    <>
    

      <Box sx={{ p: isMobile ? 1 : 0 }}>
        {/* Back Bar */}
         <Box
          sx={{
            border: "1px solid #E4E6EF",
            borderRadius: 2,
            px: 2,
            backgroundColor: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            minHeight: 55,
            mb: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              cursor: "pointer",
            }}
            onClick={onBack}
          >
            <img src={back} style={{ width: 30, height: 30 }} alt="back" />
            <CustomText
              sx={{
                ...textStyles.h1,
                fontWeight: 500,
                fontSize: "14px",
                color: "#626F86",
              }}
            >      {t("projectManagement.allTasks")} / {task.title}
            </CustomText>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: 3,
            alignItems: isMobile ? "flex-start" : "stretch",
          }}
        >
          <Box
            flex={2}
            sx={{
              backgroundColor: "#fff",
              p: 2,
              borderRadius: 2,
              height: "100%",
              border: "1px solid #E4E6EF",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center",justifyContent:"space-between" ,flexWrap:"wrap", pt: 1}}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1,}}>
              <img src={projecticon} style={{ width: 25, height: 25 }} />
              <CustomText
                sx={{
                  fontSize: 16,
                  color: "#172B4D",
                  fontWeight: 500,
                  mb: 0,
                  fontFamily: "Poppins, sans-serif",
                }}
              >
 {task.id}              </CustomText>
                  </Box>
              <Box>
                   {/* <Box sx={{ pointerEvents: "none" }}> */}

<TaskStatusDropdown
  currentStatus={task.priority}
  onChange={handlePriorityChange}
  loading={updatingPriority}
/>
        {/* </Box> */}
              </Box>
          
            </Box>

            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 18,
                mb: 3,
                mt: 2.5,
                fontWeight: 600,
                color: "#003149",
                textAlign: "left",
              }}
            >
             {task.title}
            </CustomText>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                lineHeight: 1.8,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
           {task.description}
            </CustomText>

           
      

            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 18,
                mb: 3,
                mt: 2,
                fontWeight: 600,
                color: "#003149",
                textAlign: "left",
              }}
            >
              {t("projectManagement.taskDetails")}
            </CustomText>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("projectManagement.assignedTo")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                }}
              >
  {task.assignments?.[0]?.worker_name || "—"}
              </CustomText>{" "}
            </Box>


               <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("projectManagement.status")}
              </CustomText>
                 <Box sx={{ pointerEvents: "none" }}>

                <StatusDropdown
               currentStatus={task.status} />{" "}
              </Box>
            </Box>

     <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("projectManagement.assignedOn")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                }}
              >
{formatDateTime(task.assigned_on)}         
     </CustomText>{" "}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("projectManagement.deadline")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                }}
              >
                {/* {task.end_at}{" "} */}
                 {formatDateTime(task.end_at)}
              </CustomText>{" "}
            </Box>
         

             <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                Location
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                }}
              >
                {/* {task.end_at}{" "} */}
              {task.location_address}
              </CustomText>{" "}
            </Box>

       
          

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("projectManagement.priority")}
              </CustomText>
                           <Box sx={{ pointerEvents: "none" }}>
    <StatusDropdown currentStatus={task.priority} />{" "}
    </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("projectManagement.progress")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                }}
              >
                <img src={Progress} /> 33%
              </CustomText>{" "}
            </Box>

            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 18,
                mb: 3,
                mt: 2.5,
                fontWeight: 600,
                color: "#003149",
                textAlign: "left",
              }}
            >
              {t("projectManagement.documents")}
            </CustomText>
          
            <Box
  sx={{
    display: "flex",
    flexWrap: "wrap",
    gap: 3,
    alignItems: "center",
    mb: 2,
  }}
>
  {/* {task.attachments && task.attachments.length > 0 ? (
    task.attachments.map((fileUrl, idx) => {
      const fileName = fileUrl.split("/").pop(); // get file name
      const isPdf = fileUrl.toLowerCase().endsWith(".pdf"); */}
{Array.isArray(task.attachments) && task.attachments.length > 0 ? (
  task.attachments.map((fileUrl, idx) => {
    if (!fileUrl || typeof fileUrl !== "string") {
      console.warn("⚠️ Skipping invalid attachment at index", idx, ":", fileUrl);
      return null; // ✅ Prevent crash
    }

    const fileName = fileUrl.split("/").pop();
    const isPdf = fileUrl.toLowerCase().endsWith(".pdf");
      return (
        <Box
          key={idx}
          sx={{
            width: 200,
            height: 200,
            border: "1px solid #E4E6EF",
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            p: 1,
            background: "#F9FAFB",
          }}
        >
          {isPdf ? (
            <img
              src={document1} // use your existing "document.png" icon for PDFs
              alt="pdf"
              style={{ width: 60, height: 60, marginBottom: 8 }}
            />
          ) : (
            <img
              src={document1}
              alt={fileName}
              style={{
                width: "70px",
                height: "70px",
                objectFit: "cover",
                borderRadius: 4,
                marginBottom: 8,
              }}
            />
          )}
          <Typography
            sx={{
              fontSize: 12,
              fontFamily: "Poppins, sans-serif",
              textAlign: "center",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
            }}
            title={fileName} // tooltip for full name
          >
            {fileName}
          </Typography>
        </Box>
      );
    })
  ) : (
    <Typography
      sx={{ fontSize: 14, color: "#5E5C5C", fontFamily: "Poppins, sans-serif" }}
    >
      No attachments
    </Typography>
  )}
</Box>


          </Box>

    
        </Box>
      </Box>
      <Box>
{/* Add Comment */}
<Box sx={{ p: 2, background: "#fff", mt: 2, border: "1px solid #091E4224", borderRadius: 1 }}>
  <CustomText
    sx={{
      ...textStyles.h1,
      fontSize: 18,
      fontWeight: 600,
      color: "#000",
      textAlign: "left",
    }}
  >
    {t("projectManagement.addComment")}
  </CustomText>

<Box sx={{ display: "flex", gap: 1, mt: 1, alignItems: "center" }}>
  {/* 📎 Attachment icon */}
  {/* <label htmlFor="comment-file-upload">
    <input
      id="comment-file-upload"
      type="file"
      accept="image/*"
      style={{ display: "none" }}
      onChange={handleFileChange}
    />
    <AttachFileIcon
      sx={{ cursor: "pointer", color: commentAttachment ? "#006EC2" : "#888" }}
    />
  </label> */}
    <label htmlFor="comment-file-upload">
        <input
          id="comment-file-upload"
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
        {!commentAttachment ? (
          <AttachFileIcon sx={{ cursor: "pointer", color: "#888" }} />
        ) : (
          <Box sx={{ position: "relative", display: "flex", gap: 1 }}>
            <img
              crossOrigin="anonymous"
              src={commentAttachment}
              alt="Attachment"
              style={{
                width: 60,
                height: 60,
                borderRadius: "30px",
                objectFit: "cover",
              }}
            />
            {/* Cross icon to remove attachment */}
            <ClearIcon
              onClick={handleRemoveAttachment}
              sx={{
                position: "absolute",
                top: 0,
                right: 0,
                cursor: "pointer",
                color: "white",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                borderRadius: "50%",
              }}
            />
          </Box>
        )}
      </label>

  {/* Comment input */}
  <input
    className="project_input"
    value={newComment}
    onChange={(e) => setNewComment(e.target.value)}
    placeholder={t("projectManagement.writeComment")}
    style={{ flex: 1, height: 40 }}
    disabled={sending}
  />

  {/* Add button */}
  <Button
    variant="contained"
    onClick={handleAddComment}
    disabled={sending}
    sx={{
      px: 2,
      backgroundColor: "#006EC2",
      color: "#fff",
      textTransform: "none",
      fontSize: 14,
      borderRadius: 1,
      height: 36,
      fontFamily: "Poppins, sans-serif",
    }}
  >
    {sending ? t("projectManagement.add") : t("projectManagement.add")}
  </Button>
</Box>



  {/* Comments list */}
 <Box sx={{ mt: 2, borderRadius: 2 }}>
  {comments.length === 0 ? (
    <CustomText sx={{ ...textStyles.h1, fontSize: 14, color: "#5E5C5C" }}>
 {t("projectManagement.noComments")}
    </CustomText>
  ) : (
    comments.map((c) => (
      <Box key={c.id} sx={{ p: 2, borderBottom: "1px solid #EEF2F7" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.6 }}>
               {c.attachments && c.attachments.length > 0 && (
            <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
              {c.attachments.map((file, idx) => (
           
<img
  crossOrigin="anonymous"
  alt={c.author_name}
  src={file || emptyperson }
  style={{ width: 60, height: 60, borderRadius: "30px", objectFit: "cover" }}
/>
              ))}
            </Box>
          )}
            <Box>
              <CustomText
                sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 600, color: "#100F0F" }}
              >
                {c.author_name || "-"}
              </CustomText>

              <CustomText
            sx={{ fontSize: 15, fontWeight: 400, color: "#5E5C5C", lineHeight: 1.5 }}
          >
            {(i18n.language?.split("-")[0] === "es" ? c.body_es : c.body_en) || c.body}
          </CustomText>
            
            </Box>
          </Box>

          {/* ✅ Comment badge */}
          <Box sx={{display:"flex",flexWrap:"wrap", alignItems:"center",gap:1,}}>
          <Box
            sx={{
              px: 2,
              py: 0.4,
              borderRadius: "4px",
              backgroundColor: "#E4E6EB",
              fontSize: 12,
              fontWeight: 500,
              color: "#003149",
              display: "inline-block",
                 fontFamily: 'Nunito Sans, sans-serif',
            }}
          >
            Comment
          </Box>
            <CustomText
                sx={{ ...textStyles.h1, fontSize: 13, color: "#5E5C5C", fontWeight: 400,
                     fontFamily: 'Nunito Sans, sans-serif',
                 }}
              >
                {formatDateTime(c.created_at)}
              </CustomText>
              </Box>
        </Box>

       
      </Box>
    ))
  )}
</Box>
</Box>

     
      </Box>
    </>
  );
};
export default TaskDetails
